// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_2txsg","flag":"index_flag_3DcOS","menuIcon":"index_menuIcon_2f5EJ"};